export { default } from "./PromoCard";
